import React, { useState } from "react";
import RequestService from "../../services/request.service";


import { Button, Modal, Table } from 'react-bootstrap'


import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import moment from 'moment'

import { toast } from 'react-toastify'


import '../Reportes/mi_reporte.scss';


import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);


const ModalReporteAsesor = ( props ) => {

	const { showDetallesAsesor, handleCloseModalAsesor, asesor_detalle } = props


  const [ detalle_asesor, setDetalleAsesor ] = useState<any>({
  	acumulado_departamentos : [],
  	rendimiento_mensual : [],
  })


const cargarData = async () =>{
	 let req = await RequestService.getEndPoint('gerente/detalle_asesor/'+asesor_detalle.uuid)
  	setDetalleAsesor(req.data)
}


  React.useEffect(() => {
    cargarData()
  }, []);


  const [ reporte, setReporte ] = useState<any>({
  	acumulados_estatus : []
  })
  const cargarMiReporte = async()=>{
    try{
      setCargando(true)
      // var uuid_sucursal = "mmm"
      // let uuids_sucursales = etiquetas_seleccionadas.map( (sucursal:any)=> sucursal.value )
      var ED = endDate ? moment(endDate).format('YYYY-MM-DD') : null
      let response = await RequestService.getEndPoint('gerencia/reporte_asesor/'+asesor_detalle.uuid+'/'+moment(startDate).format('YYYY-MM-DD')+'/'+ ED )
      setReporte(response.data)
      setCargando(false)

      setStartDate_(startDate)
      setEndDate_(endDate)
      // setEtiquetasSeleccionada_([...etiquetas_seleccionadas])
      // toast.success('La lista de Tramites del día '+fecha+' fue cargada')
    }
    catch(e){
      setCargando(false)
      toast.error('Problemas al intentar generar tu reporte. Contacta con los administradores del sistema')
    }
  }


  // React.useEffect(() => {
  //   cargarMiReporte()
  // }, []);


	
const options = {
  responsive: true,
  interaction: {
    mode: 'index' as const,
    intersect: false,
  },
  stacked: false,
  plugins: {
    title: {
      display: true,
      text: 'Chart.js Line Chart - Multi Axis',
    },
  },
  scales: {
    y: {
      type: 'linear' as const,
      display: true,
      position: 'left' as const,
    },
    y1: {
      type: 'linear' as const,
      display: true,
      position: 'right' as const,
      grid: {
        drawOnChartArea: false,
      },
    },
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];


const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: [123,1234,425,5324,45,234,654],
      borderColor: '#6ab3a2',
      backgroundColor: '#3d4647',
      yAxisID: 'y',
    },
    // {
    //   label: 'Dataset 2',
    //   data: [1234,4323,24345,24342,123123,523,13],
    //   borderColor: 'rgb(53, 162, 235)',
    //   backgroundColor: '#48615e',
    //   yAxisID: 'y1',
    // },
  ],
};

const [ cargandoReporte, setCargando ] = useState<boolean>(true)

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());


  const [startDate_, setStartDate_] = useState(new Date());
  const [endDate_, setEndDate_] = useState(new Date());


  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    // cargarMiReporte()
  };



  const actualizarReporte = async()=>{
  	setCargando(true)
  	cargarMiReporte()

  }

	return (



      <Modal show={showDetallesAsesor} size="lg" backdrop="static" onHide={handleCloseModalAsesor}>
        <Modal.Header closeButton>
          <Modal.Title>
          		<h5 className="nm">Detalle del Asesor</h5>

          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        	
        	{
        		// JSON.stringify(asesor_detalle)
        	}

            <div className="row">
                <div className="col-8">
                    <h2>{asesor_detalle.nombres} {asesor_detalle.paterno} {asesor_detalle.materno}</h2>
                    <p><strong>Usuario: </strong> {asesor_detalle.username} </p>
                    <p><strong>Email: </strong> {asesor_detalle.email} </p>
                    <p><strong>Celular: </strong> {asesor_detalle.celular} </p>
                </div>             
                <div className="col-4">

				    <DatePicker
				    	maxDate={new Date()}
				      selected={startDate}
				      onChange={onChange}
				      startDate={startDate}
				      endDate={endDate}
				      selectsRange
				      inline
				    />

				    <button type="button" onClick={actualizarReporte} className="btn btn-link"><small>Actualizar Reporte</small></button>

                </div>
            </div>


                    <hr />

                    {

                    	!cargandoReporte && (


                    		<React.Fragment>

                                    <h4 className="mt-4">
                                      {
                                        moment(startDate_).format('YYYY-MM-DD') !== moment(endDate_).format('YYYY-MM-DD') && ('REPORTE ENTRE '+ moment(startDate_).format('DD [DE] MMMM [DEL] YYYY').toUpperCase() + ' Y EL ' + moment(endDate_).format('DD [DE] MMMM [DEL] YYYY').toUpperCase() )
                                      }
                                      {
                                        moment(startDate_).format('YYYY-MM-DD') === moment(endDate_).format('YYYY-MM-DD') && ('REPORTE PARA EL '+moment(startDate_).format('DD [DE] MMMM [DEL] YYYY').toUpperCase())
                                      }
                                    </h4>





								<div className="row">
									<div className="col-5">

                      			<h6>REPORTE DE TRÁMITES POR ESTATUS</h6>

<ul className="list-group list-group-flush">
{
	reporte.acumulados_estatus.map((estatus:any)=>
  	<li className={`list-group-item d-flex justify-content-between align-items-center ${ estatus.tramites === 0 ? 'disabled' : '' }`} key={ Math.random().toString(36).substr(2, 9) }>
  			<small><b>{estatus.estatus}</b></small>
  			<span className={`badge  bg- rounded-pill estatus_${estatus.id}`}>{estatus.tramites}</span>
  	</li>
  )
}
</ul>
									</div>
									<div className="col-7">
										<Line options={options} data={data} />
									</div>
								</div>




                    		</React.Fragment>

                    	)



                    }



        </Modal.Body>
      </Modal>





	)


}


export default ModalReporteAsesor

